import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { popupItemStyles } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { PopupInfoCard } from 'APP/components/PopupInfoCard/PopupInfoCard';
import { VerifiedBadge } from 'APP/components/VerifiedBadge/VerifiedBadge';
import { User } from 'STORE/Users/User/User';

import { usePopupUserItemPresenter } from './PopupUserItem.presenter';
import styles from './PopupUserItem.styles.m.css';
import { PopupUserItemClickHandler } from './PopupUserItem.types';

interface IPopupUserItemProps {
  user: User;
  hint?: string;
  hintClassName?: string;
  onClick?: PopupUserItemClickHandler;
  subtitleText?: string;
}

export const PopupUserItem: FC<IPopupUserItemProps> = observer((props) => {
  const { user, hint, hintClassName, onClick, subtitleText } = props;
  const { userOnlineStatusText } = usePopupUserItemPresenter({ user });

  const classes = classNames(popupItemStyles.container, {
    [popupItemStyles.interactive]: Boolean(onClick),
  });

  const content = (
    <>
      <PopupInfoCard
        type={AvatarTypes.Round_10}
        className={popupItemStyles.card}
        avatarTitle={user.avatarTitle}
        avatarUrl={user.avatarUrl || undefined}
        avatarBackgroundColorIndex={user.avatarColorIndex}
        title={user.displayName}
        subtitle={subtitleText || userOnlineStatusText}
        badge={user.verified && <VerifiedBadge />}
      />
      {hint && (
        <span className={classNames(popupItemStyles.hint, styles.hint, hintClassName)}>{hint}</span>
      )}
    </>
  );

  if (!onClick) {
    return <div className={classes}>{content}</div>;
  }

  return (
    <button
      onClick={(): void => onClick(user)}
      className={classes}
    >
      {content}
    </button>
  );
});
